import React from 'react';

import { observer } from 'mobx-react';

import type { ExtraRowsProps } from 'components/Entities/EntityDetailsTab/entityFieldConfig';
import EntityRowWrapper from 'components/Entities/EntityDetailsTab/RowWrapper';
import { StyledDivider, StyledRowWrapper } from 'components/Entities/EntityDetailsTab/styles';
import EvidenceFiles from 'components/EvidenceFiles/EvidenceFiles';
import { savedEvidenceFiles } from 'components/EvidenceFiles/utils';
import ControlsDetailsStore from 'stores/ControlsDetails/ControlsDetails';
import { formatMoment } from 'utils/formatters/timezone';
import { choiceKeyOf } from 'utils/library';

import { CONTROL_FIELD, ControlStatus } from '../../constants';
import { EvidenceText } from './styles';

const ControlPutInPlaceRows: React.FunctionComponent<ExtraRowsProps> = ({ store, fieldOrder }) => {
  if (!(store instanceof ControlsDetailsStore) || !fieldOrder.includes(CONTROL_FIELD.status)) return null;
  const { putInPlace } = store;
  const inPlace = choiceKeyOf(store.details?.entity[CONTROL_FIELD.status]?.value) === ControlStatus.InPlace;
  if (!putInPlace || !inPlace) return null;

  return (
    <>
      <StyledRowWrapper>
        <StyledDivider />
      </StyledRowWrapper>
      <EntityRowWrapper rowName="Put in place" withDivider={Boolean(putInPlace.evidence)}>
        <p data-testid="control-put-in-place">
          {formatMoment(putInPlace.completedAt)} by {putInPlace.completedBy?.name ?? 'N/A'}
        </p>
      </EntityRowWrapper>
      {putInPlace.evidence && (
        <EntityRowWrapper rowName="Evidence" withDivider={false}>
          <div data-testid="control-evidence">
            <EvidenceText>{putInPlace.evidence.text}</EvidenceText>
            <EvidenceFiles files={savedEvidenceFiles(putInPlace.evidence.attachments)} />
          </div>
        </EntityRowWrapper>
      )}
    </>
  );
};

export default observer(ControlPutInPlaceRows);
